/**
 * O que cada papel do painel pode ver, igual ao admin atual.
 *
 * Origem: `aplicarRestricoesDePapel` (`portal/admin.html:3425`) esconde abas por papel, e
 * `verificarAcesso` (`admin.html:3523`) abre financeiro e marketing direto em Vendas. Aqui a
 * mesma regra vira dado: permissões por papel, que o Chassi usa para montar o menu, e a rota inicial.
 */

// As permissões do Painel e das oito áreas, com os mesmos nomes que o manifesto declara no menu.
const TODAS = [
  'painel:ver',
  'compromissos:ver',
  'clientes:ver',
  'vendas:ver',
  'matriz:ver',
  'depoimentos:ver',
  'financeiro:ver',
  'arquivos:ver',
  'sistema:ver',
] as const;

// Papel por papel, como o admin atual esconde as abas.
const PERMISSOES_POR_PAPEL: Readonly<Record<string, readonly string[]>> = Object.freeze({
  // Vê tudo.
  administrador: TODAS,
  // Tudo menos Sistema: "papelAtual !== 'administrador'" esconde a aba de parâmetros.
  consulta: TODAS.filter((p) => p !== 'sistema:ver'),
  // Só Vendas e Financeiro (e o Painel, que mostra só essas duas): as outras seis ficam escondidas.
  financeiro: ['painel:ver', 'vendas:ver', 'financeiro:ver'],
  // Só Vendas (e o Painel, que mostra só ela): esconde também o Financeiro.
  marketing: ['painel:ver', 'vendas:ver'],
});

// As permissões de um papel. Papel desconhecido não vê nada, que é o lado seguro.
export function permissoesDoPapel(papel: string): readonly string[] {
  return PERMISSOES_POR_PAPEL[papel] ?? [];
}

/**
 * A área em que a pessoa entra: o Painel, para todos os papéis, desde 19/09/2026.
 *
 * No admin atual financeiro e marketing abriam em Vendas e os outros em Compromissos
 * (`admin.html:3523`). O Painel é a porta de entrada que o fundador pediu, e ele mostra a cada
 * papel só as áreas que aquele papel vê, então ninguém cai numa área que não é dele.
 */
export function rotaInicial(_papel: string): string {
  return '/painel';
}
